import styled from 'styled-components';
import calendarIcon from '../../../../../images/common/icons/calendar.gif';

export const DateInputRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3px;
`;

export const DateInputIcon = styled.img.attrs({
  src: calendarIcon,
  alt: 'Calendar Icon'
})`
  height: 16px;
  width: 16px;
  flex-shrink: 0;
`;